import { useState } from "react";

const images = [
  "/Images/Pitstop.png",
  "/Images/Turbo.png",
  "/Images/Himalayan.png",
  "/Images/EV.png",
  "/Images/Voith.png",
  "/Images/Blogs.png",
  "/Images/Mobile.png",
  "/Images/Hajir.png",
  "/Images/Rental.png",
 ];

const CARD_WIDTH = 600;
const CARD_HEIGHT = 240;
const CARD_VISIBLE_WIDTH = 80; 
const CARD_HOVER_HEIGHT = 500; 
const MOBILE_CARD_WIDTH = 180;
const MOBILE_CARD_HEIGHT = 80;
const MOBILE_CARD_HOVER_HEIGHT = 180;
const heightIncrements = [0, 60, 120, 180, 240, 180, 120, 60];

const CreativeLibrary = () => {
  const [hovered, setHovered] = useState(-1);
  const customTops = [0, 30, 20, 10, 15, 25, 10, 0]; // Only positive or zero


  // Responsive card sizing
  const isMobile = typeof window !== "undefined" && window.innerWidth < 560;

  return (
    <section className="relative bg-white bg-gradient-to-b from-white to-neutral-100 text-black rounded-3xl mx-4 sm:mx-6 mt-10" style={{ minHeight: "8vh" }} data-bg="light">
      {/* Heading and Button */}
      <div className="flex flex-col items-center pt-6 sm:pt-10">
        <h2 className="text-2xl sm:text-5xl font-extrabold mb-6 sm:mb-8 tracking-tight mt-8">Browse my creative library</h2>
        <a
          href="/work"
          className="inline-flex items-center px-6 sm:px-8 py-2 sm:py-3 bg-black text-white font-semibold rounded-full shadow hover:bg-gray-600 transition-colors duration-300 text-base sm:text-lg"
        >
          View archives <span className="ml-2 text-xl text-white">→</span>
        </a>
      </div>
      {/* Overlapping Card Deck */}
      <div className="relative flex justify-center items-end pb-8 min-h-[370px] sm:min-h-[600px]">
        <div className="flex flex-row justify-center items-end px-2 sm:px-8 overflow-x-auto flex-nowrap scrollbar-thin scrollbar-thumb-gray-300" style={{gap: 10}}>
          {images.map((img, idx) => {
            const isHovered = hovered === idx;
            const anyHovered = hovered !== -1;
            // Responsive card sizing
            const containerWidth = isMobile ? MOBILE_CARD_WIDTH : CARD_WIDTH;
            const cardHeight = (isMobile ? MOBILE_CARD_HEIGHT : CARD_HEIGHT) + (heightIncrements[idx] || 0);
            let containerHeight, marginTop;
            if (anyHovered) {
              if (isHovered) {
                containerHeight = isMobile ? MOBILE_CARD_HOVER_HEIGHT : CARD_HOVER_HEIGHT;
                marginTop = 0;
              } else {
                containerHeight = isMobile ? MOBILE_CARD_HEIGHT : CARD_HEIGHT / 1.3;
                marginTop = 0;
              }
            } else {
              containerHeight = cardHeight / 1.3;
              marginTop = customTops[idx] || 0;
            }
            let zIndex = 40 - idx;
            const marginLeft = idx === 0 ? 0 : `-${containerWidth - (isMobile ? 40 : CARD_VISIBLE_WIDTH)}px`;
            return (
              <div
                key={img}
                className={`relative rounded-t-4xl transition-[box-shadow] duration-500 group shrink-0`}
                style={{
                  width: `${containerWidth}px`,
                  height: `${containerHeight}px`,
                  marginLeft,   
                  marginTop,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'width 0.7s, height 0.7s, box-shadow 0.7s, margin-top 0.7s',
                  zIndex,
                }}
                onMouseEnter={() => setHovered(idx)}
                onMouseLeave={() => setHovered(-1)}
              >
                <img
                  src={img}
                  alt={`Project ${idx + 1}`}
                  className="w-full h-full object-cover rounded-t-2xl transition-all duration-500"
                  style={{
                    objectPosition: 'top'
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CreativeLibrary;